'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _detectIt = require('detect-it');

var _detectIt2 = _interopRequireDefault(_detectIt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BREAK_PTS = {
  small: 375,
  medium: 544,
  xmedium: 700,
  large: 1008,
  xlarge: 1327
};

var ScreenService = function ScreenService() {
  var _this = this;

  _classCallCheck(this, ScreenService);

  this.onWindowResize = (0, _lodash.debounce)(function (event) {
    _this.width = window.innerWidth;
  }, 100);

  this.isSmallDevice = function () {
    return _this.width <= BREAK_PTS.xmedium;
  };

  this.isLargeDevice = function () {
    return _this.width > BREAK_PTS.xmedium;
  };

  this.isMobile = function () {
    return _this.width < BREAK_PTS.medium;
  };

  this.isTabletSmall = function () {
    return _this.width >= BREAK_PTS.medium && _this.width < BREAK_PTS.xmedium;
  };

  this.isTabletLarge = function () {
    return _this.width >= BREAK_PTS.xmedium && _this.width < BREAK_PTS.large;
  };

  this.isTablet = function () {
    return _this.width >= BREAK_PTS.medium && _this.width < BREAK_PTS.large;
  };

  this.isDesktop = function () {
    return _this.width >= BREAK_PTS.large && _this.width < BREAK_PTS.xlarge;
  };

  this.isDesktopHD = function () {
    return _this.width >= BREAK_PTS.xlarge;
  };

  this.isHybridDevice = function () {
    return _detectIt2.default.deviceType === 'hybrid';
  };

  this.isTouchDevice = function () {
    return _detectIt2.default.deviceType === 'touchOnly' || _detectIt2.default.deviceType === 'hybrid';
  };

  this.isMouseDevice = function () {
    return _detectIt2.default.deviceType === 'mouseOnly' || _detectIt2.default.deviceType === 'hybrid';
  };

  this.width = window.innerWidth;
  window.addEventListener('resize', this.onWindowResize);
};

exports.default = new ScreenService();


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/services/screenService.js
// module id = 101
// module chunks = 0